export default "__VITE_ASSET__C77WWjjI__"